module.exports = __webpack_public_path__ + "img/1800.0eaee40e.jpg";